<div class="datablock">

  <!-- MaxSpeed -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Max allowed speed' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="maxSpeed"
          [ngModelOptions]="{ standalone: true }"
          #maxSpeed="ngModel"
          (blur)="maxSpeedVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="maxSpeed.errors?.max && maxSpeedVisited"
          [ngModel]="Object.MaxSpeed | localizeSpeed"
          (ngModelChange)="convertMaxSpeed($event)"
          [max]="Object.DangerousSpeed | localizeSpeed"
          aria-describedby="maxSpeedError"
        />

        <span class="inputwrap__unit">
          {{ 'km/h' | localizeUnits }}
        </span>
      </div>

      <!-- <div
        id="maxSpeedError"
        class="field-error"
        *ngIf="maxSpeed.errors?.max && maxSpeedVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'MaxSpeed must be less than or equal to DangerousSpeed' | translate }}
        </span>
      </div> -->
    </div>
  </div>


  <!-- DangerousSpeed -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Dangerous speed' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="dangerousSpeed"
          [ngModelOptions]="{ standalone: true }"
          #dangerousSpeed="ngModel"
          (blur)="dangerousSpeedVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="dangerousSpeed.errors?.min && dangerousSpeedVisited"
          [ngModel]="Object.DangerousSpeed | localizeSpeed"
          (ngModelChange)="convertDangerousSpeed($event)"
          [min]="Object.MaxSpeed | localizeSpeed"
          aria-describedby="dangerousSpeedError"
        />

        <span class="inputwrap__unit">
          {{ 'km/h' | localizeUnits }}
        </span>
      </div>

      <div
        id="dangerousSpeedError"
        class="field-error"
        *ngIf="dangerousSpeed.errors?.min && dangerousSpeedVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Dangerous setting must be greater than or equal to Harsh' | translate }}
        </span>
      </div>
    </div>
  </div>


  <!-- HarshAcceleration -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Harsh acceleration' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="harshAcceleration"
          [ngModelOptions]="{ standalone: true }"
          #harshAcc="ngModel"
          (blur)="harshAccVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="harshAcc.errors?.max && harshAccVisited"
          [ngModel]="Object.HarshAcceleration"
          (ngModelChange)="convertHarshAcceleration($event)"
          [max]="getMax(Object.DangerousAcceleration)"
          aria-describedby="harshAccError"
        />

        <span class="inputwrap__unit">
          {{ 'g'  }}
        </span>
      </div>

      <!-- <div
        id="harshAccError"
        class="field-error"
        *ngIf="harshAcc.errors?.max && harshAccVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Harsh must be less than or equal to Dangerous' | translate }}
        </span>
      </div> -->
    </div>
  </div>


  <!-- DangerousAcceleration -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Dangerous acceleration' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="dangerousAcceleration"
          [ngModelOptions]="{ standalone: true }"
          #dangerousAcc="ngModel"
          (blur)="dangerousAccVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="dangerousAcc.errors?.min && dangerousAccVisited"
          [ngModel]="Object.DangerousAcceleration "
          (ngModelChange)="convertDangerousAcceleration($event)"
         [min]="getMin(Object.HarshAcceleration)"
          aria-describedby="dangerousAccError"
        />

        <span class="inputwrap__unit">
          {{ 'g' }}
        </span>
      </div>

      <div
        id="dangerousAccError"
        class="field-error"
        *ngIf="dangerousAcc.errors?.min && dangerousAccVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Dangerous setting must be greater than or equal to Harsh' | translate }}
        </span>
      </div>
    </div>
  </div>


  <!-- HarshBreaking -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Harsh breaking' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="harshBreaking"
          [ngModelOptions]="{ standalone: true }"
          #harshBr="ngModel"
          (blur)="harshBrVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="harshBr.errors?.max && harshBrVisited"
          [ngModel]="Object.HarshBreaking "
          (ngModelChange)="convertHarshBreaking($event)"
           [max]="getMax(Object.DangerousBreaking)"
          aria-describedby="harshBrError"
        />

        <span class="inputwrap__unit">
          {{ 'g'  }}
        </span>
      </div>

      <!-- <div
        id="harshBrError"
        class="field-error"
        *ngIf="harshBr.errors?.max && harshBrVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Harsh must be less than or equal to Dangerous' | translate }}
        </span>
      </div> -->
    </div>
  </div>


  <!-- DangerousBreaking -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Dangerous breaking' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="dangerousBreaking"
          [ngModelOptions]="{ standalone: true }"
          #dangerousBr="ngModel"
          (blur)="dangerousBrVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="dangerousBr.errors?.min && dangerousBrVisited"
          [ngModel]="Object.DangerousBreaking "
          (ngModelChange)="convertDangerousBreaking($event)"
          [min]="getMin(Object.HarshBreaking)"
          aria-describedby="dangerousBrError"
        />

        <span class="inputwrap__unit">
          {{ 'g'  }}
        </span>
      </div>

      <div
        id="dangerousBrError"
        class="field-error"
        *ngIf="dangerousBr.errors?.min && dangerousBrVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Dangerous setting must be greater than or equal to Harsh' | translate }}
        </span>
      </div>
    </div>
  </div>


  <!-- Harsh turning -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Harsh turning' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="harshTurn"
          [ngModelOptions]="{ standalone: true }"
          #harshTurn="ngModel"
          (blur)="harshTurnVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="harshTurn.errors?.max && harshTurnVisited"
          [ngModel]="Object.HarshTurn "
          (ngModelChange)="convertHarshTurn($event)"
          [max]="getMax(Object.DangerousTurn)"
          aria-describedby="harshTurnError"
        />

        <span class="inputwrap__unit">
          {{ 'g'  }}
        </span>
      </div>

      <!-- <div
        id="harshTurnError"
        class="field-error"
        *ngIf="harshTurn.errors?.max && harshTurnVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Harsh must be less than or equal to Dangerous' | translate }}
        </span>
      </div> -->
    </div>
  </div>


  <!-- DangerousTurn -->
  <div class="inputgroup">
    <label class="inputgroup__label">
      {{ 'Dangerous turn' | translate }}
    </label>

    <div class="inputgroup__control">
      <div class="inputwrap">
        <input
          name="dangerousTurn"
          [ngModelOptions]="{ standalone: true }"
          #dangerousTurn="ngModel"
          (blur)="dangerousTurnVisited = true"
          [readonly]="!canEditTrackers"
          type="number"
          class="inputwrap__input"
          [class.inputwrap__input--invalid]="dangerousTurn.errors?.min && dangerousTurnVisited"
          [ngModel]="Object.DangerousTurn "
          (ngModelChange)="convertDangerousTurn($event)"
           [min]="getMin(Object.HarshTurn)"
          aria-describedby="dangerousTurnError"
        />

        <span class="inputwrap__unit">
          {{ 'g'  }}
        </span>
      </div>

      <div
        id="dangerousTurnError"
        class="field-error"
        *ngIf="dangerousTurn.errors?.min && dangerousTurnVisited"
      >
        <span class="field-error__icon">⚠</span>
        <span class="field-error__text">
          {{ 'Dangerous setting must be greater than or equal to Harsh' | translate }}
        </span>
      </div>
    </div>
  </div>

</div>
